import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { getProductDetailsLink } from 'apps/products/links';

export default class SellingGroupOptionsButton extends PureComponent {
  static propTypes = {
    product: PropTypes.object.isRequired,
    basketQuantity: PropTypes.number.isRequired,
  };

  render() {
    const { basketQuantity, product } = this.props;

    const productDetailsLink = getProductDetailsLink({ product });
    const buttonContent = (basketQuantity > 0) ? (
      <Link to={productDetailsLink} className="fop-btn-choose">
        <span className="fop-in-trolley">{basketQuantity}</span>
        <span className="fop-btn-view-details">View details</span>
      </Link>
    ) : (
      <Link to={productDetailsLink} className="fop-btn-choose">
        <span className="fop-btn-bop-link">Choose options</span>
      </Link>
    );

    return (
      <div className="fop-add-choose">
        {buttonContent}
      </div>
    );
  }
}
